<div class="ml-8 mt-20" *transloco="let t">
  <h1 class="mb-8 text-3xl font-semibold">
    {{ t('admin.customerOverview.customerList') }}
  </h1>
  <div class="w-2/3">
    <app-organizations-table />
  </div>
</div>
